class SiteLabelMarkdown 
    extends SiteLabel<string, ISiteLabelConfig> {

    private _input: IQueryElement;
    private _easyMDE: any;
    private _siteCard: SiteCard;
    private _labelUpload?: SiteLabelUpload;

    constructor(card: SiteCard, model: ISiteModel, modelData: ISiteModel, element: HTMLElement) {
        super(card, model, modelData, element);

        let input = this.query("textarea").first();

        if(input === null)
            throw 'SiteLabelMarkdown: Missing element(s)';
        
        this._input = input;
        this._siteCard = card;

        this._easyMDE = new EasyMDE({
            element: input.get(),
            spellChecker: false,
            //forceSync: true,
            autoDownloadFontAwesome: false,
            previewClass: "markdown-preview",
            status: false,
            previewImagesInEditor: true,
            uploadImage: true,
            imagesPreviewHandler: (src:string) => this.imageSrcGet(src),
            imageUploadFunction: (
                file: File,
                onSuccess: (imageUrl: string) => void,
                onError: (errorMessage: string) => void
            ) => this.imageUploadFunction(file, onSuccess, onError)
        })

    }

    init(input?: IQueryElement) {
        let value = this.getModelValue();
        this._easyMDE.value(value);

        var attachments = this._input.getAttr("data-attachments");
        if (attachments != null) {
            this._labelUpload = this._siteCard.getLabel(QueryJSON.toCamelCase(attachments)) as SiteLabelUpload;
        }
    }

    imageSrcGet(src: string) {
        if (this._labelUpload == null)
            throw "No labelUpload set.";
        
        switch(this._labelUpload.getProvider())
        {
            case "attachment":
                return `${window.location.origin}/Api/FileAttachmentGet/${src}`;
            case "image":
                return `${window.location.origin}/Api/FileImageGet/${src}`;
        }
    }

    async imageUploadFunction(
        file: File,
        onSuccess: (imageUrl: string) => void,
        onError: (errorMessage: string) => void
    ) {
        if (this._labelUpload == null)
            return onError("No labelUpload set..");
        
        var upload = await this._labelUpload.addFile(new QueryUploadFileUpload(file));
        if (upload.state == "succeeded") {
            onSuccess(upload.id.objectName.split("/")[1]);
        } else {
            onError("Upload failed!");
        }
    }

    getInput() {
        return this._input;
    }
    makeActive() {
        if(super.makeActive()) {
            this._easyMDE.codemirror.focus();
            return true;
        }
        return false;
    }
    makeInactive() {
        super.makeInactive();
    }
    defaultConfig(): ISiteLabelConfig {
        return {
            popout: "normal",
            scroll: "top"
        }
    }

    getValue() {
        let value = this._easyMDE.value();
        return !value ? null : value;
    }
    setValue(value: string | null) {
        super.setValue(value);
        this._input.setVal(value);
    }
} 